import { create } from 'zustand'

import { IStore, store } from 'app/store/storage'

const globalState = create(() => store)

export const useGlobalState = <T extends keyof IStore>(key: T) =>
  globalState(
    (state) =>
      [
        state[key],
        (value: IStore[T]) => {
          globalState.setState({ [key]: value })
        },
      ] as const,
  )

export const setGlobalState = globalState.setState
export const getGlobalState = globalState.getState

export const refreshGlobalState = () => {
  globalState.setState(store)
}
